import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * Muestra el nombre de un recurso relacionado y, si está borrado lógicamente, añade "(borrado)" en rojo.
 *
 * Funciona con cualquier relación auditada, sin importar de qué cuelgue
 * (transaction.thirdParty, case.thirdParty, caseService.thirdParty, processor, worker, ...): recibe
 * el propio recurso relacionado, no su padre. El flag `deleted` viaja en todas las entidades que
 * heredan de AuditEntity en el backend, así que siempre está disponible aunque la clase del frontend
 * no lo declare.
 *
 * Uso: <app-deleted-label [resource]="transaction.thirdParty"></app-deleted-label>
 *      <app-deleted-label [resource]="case.thirdParty" field="legalName"></app-deleted-label>
 */
@Component({
    selector: 'app-deleted-label',
    imports: [CommonModule],
    template: `{{ display }}<span *ngIf="resource?.deleted" class="deleted-mark"> ({{ label }})</span>`,
    styles: [`.deleted-mark { color: #d32f2f; }`]
})
export class DeletedLabelComponent {
  @Input() resource: any;
  @Input() field: string = 'name';
  @Input() label: string = 'borrado';

  get display(): string {
    return this.resource?.[this.field] ?? '';
  }
}
